import Container from "react-bootstrap/Container";
import { motion, useScroll, useTransform  } from "framer-motion";
import { Button, Card, Col, Image, Row, Carousel } from "react-bootstrap";
import { ExpandableComponent } from "../../components/ExpandableComponent";
import { useEffect, useRef } from "react";
import personalDataJSON from "./personalData.json";

interface ResearchArea {
  title: string;
  image: string;
  relatedResearch: {
    title: string;
    doi: string;
  }[];
}

interface FeaturedResearch {
  title: string;
  journal: string;
  doi: string;
  year: number
}

const highlightedWordColor = "rgb(65, 129, 224)";

export const Home = () => {
  useEffect(() => {
    document.title = "Mohamad Tarabin - Home";
  }, []);

  // This fixes the scrolling when directed to home page url with a specific section id (#)
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.substring(1);

      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }, []);

  const isMobile = window.innerWidth < 768;

  // Fading effect of the HERO section as you scroll down
  const heroRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({ target: heroRef, offset: ["start start", "end start"] }); // This tells frame to track this particular element (heroRef)
  //What does offset: ["start start", "end start"] mean? The first word refers to the hero. The second word refers to the viewport.
  //The second condition (for a scrollYProgress = 1) happens when the end of the hero reaches the start of the viewport. This means you passed it
  const heroOpacity = useTransform(scrollYProgress, [0.1, 1], isMobile ? [1, 1] : [1, 0.1]); // The first pair of values are for the scrollYProgress, while the second 2 values are for opacity

  const researchAreas: ResearchArea[] = personalDataJSON.research_areas;
  const featuredResearch: FeaturedResearch[] = personalDataJSON.featured_research;

  return (
      <>

        {/* Hero Section */}
        {/* Hero Section */}
        {/* Hero Section */}

        <motion.div ref={heroRef} style={{ opacity: heroOpacity, marginBottom: "150px" }}>
        <Row>
          <Col
            xs={{ span: 12 }}
            lg={{ span: 3, order: 0, offset: 1 }}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              marginTop: "100px",
              // backgroundColor:"blue"
            }}
          >
            <h1>
              Hi, I'm{" "}
              <span style={{color: highlightedWordColor, fontWeight: "bold"}}>Mohamad Tarabin</span>
            </h1>
            Ph.D. · CIVIL ENGINEERING

            {/* <h1 className="mt-5">
              I'm a Civil Engineer and a Scientific Researcher.
            </h1> */}

            <h1 className="mt-5">Welcome to my Portfolio!</h1>

            
            <motion.div
              whileHover={{ scale: 1.2 }}
              transition={{ duration: 1 }}
            >
              <Image
                src={"images/HomePage/Me.JPG"}
                fluid
                style={{ marginTop: "50px", maxWidth: "600px" }}
              />
            </motion.div>

          </Col>

          <Col
          xs={{ span: 12 }}
          lg={{ span: 6, offset:1 }}
          style={{ 
            marginTop: "100px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
          >
            
          <FloatingParticle delay={0} x={10} y={15} />
          <FloatingParticle delay={0} x={35} y={25} />
          <FloatingParticle delay={1} x={85} y={20} />
          <FloatingParticle delay={2} x={75} y={90} />
          <FloatingParticle delay={0.5} x={50} y={75} />
          <FloatingParticle delay={1.5} x={50} y={35} />

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{
              color: "#7da0ff",
              // fontSize: "12px",
              // letterSpacing: "3px",
              // fontWeight: 700,
              marginBottom: "20px",
            }}
          >
            CIVIL ENGINEER · RESEARCHER · INNOVATOR
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            style={{
              fontSize: "clamp(48px, 5vw, 80px)",
              lineHeight: 0.98,
              letterSpacing: "-3px",
              fontWeight: 800,
              margin: 0,
            }}
          >
            Engineering the next generation of{" "}
            <span
              style={{
                color: highlightedWordColor
              }}
            >
              safe and sustainable concrete
            </span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
            style={{
              maxWidth: "700px",
              color: "#a7b0c0",
              marginTop: "35px",
            }}
          >
            I am a civil engineer and researcher working at the intersection of{" "}
            <strong style={{ color: "white" }}>nuclear infrastructure</strong>,{" "}
            <strong style={{ color: "white" }}>sustainable high-performance construction materials</strong>,
            and <strong style={{ color: "white" }}>computational engineering</strong>.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.6 }}
            style={{ display: "flex", gap: "15px", marginTop: "35px", flexWrap: "wrap", justifyContent: "center",}}
          >
            <Button
              href="#research"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "15px",
                padding: "14px 23px",
                fontWeight: 600,
                background: "#4d7cff",
                color: "white",
                border: "none",
              }}
            >
              Explore My Research <span>↓</span>
            </Button>

            <Button
              href="research"
              variant="outline-light"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "15px",
                padding: "14px 23px",
                borderRadius: "7px",
                fontWeight: 600,
                background: "rgba(255,255,255,0.03)",
                border: "1px solid rgba(255,255,255,0.14)",
                color: "white",
              }}
            >
              View Publications <span>→</span>
            </Button>
          </motion.div>



          </Col>

        </Row>
        </motion.div>


        <ResearchSection researchAreas={researchAreas} featuredResearch={featuredResearch} isMobile={isMobile} />

        <SoftwareSection/>

        {/* Page bottom director */}
        {/* Page bottom director */}
        {/* Page bottom director */}
        <Container
          style={{
            marginTop: "150px",
            marginBottom: "100px",
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            viewport={isMobile ? { once: true } : { once: false }}
          >
            <h1
              className="text-center"
              style={{
                marginBottom: "40px",
              }}
            >
              You have reached the end of the home page. Check out my{" "} <span style={{ color: highlightedWordColor }}>other pages!</span>
            </h1>
          </motion.div>

          <Row>
            <RedirectCard title="About me" buttonText="View about me" image="images/HomePage/Me2.jpeg"
             href="aboutme" viewDelayOffset={0.25} isMobile={isMobile}/>

            <RedirectCard title="Research" buttonText="View publications" image="https://ars.els-cdn.com/content/image/1-s2.0-S2352710224005370-gr7_lrg.jpg"
             href="research" viewDelayOffset={0.5} isMobile={isMobile} />

            <RedirectCard title="Developments" buttonText="View developments" image="images/HomePage/Coding.JPG"
             href="developments" viewDelayOffset={0.75} isMobile={isMobile} />

            <RedirectCard title="Awards" buttonText="View awards" image="images/Awards/Abu Dhabi University/Honors/2017-2018 Fall.jpg"
             href="awards" viewDelayOffset={1} isMobile={isMobile} />

          </Row>
        </Container>

        <CollaborationSection/>

      </>
  );
};

type RedirectCardProps = {
  title: string;
  buttonText: string;
  image: string;
  href: string;
  isMobile: boolean;
  viewDelayOffset: number;
};

function RedirectCard({ title, buttonText, image, href, isMobile, viewDelayOffset }: RedirectCardProps) {
  return (
    <Col
      xs={{ span: 12, order: 0 }} // < 576 px
      sm={{ span: 6, order: 0 }} // > 576 px
      lg={{ span: 3, order: 0 }} // > 992 px
      style={{ marginBottom: "30px" }}
    >
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={
          isMobile ? { duration: 0.5, delay: 0.5 } : { duration: 0.5, delay: 0.5 + viewDelayOffset*1.5 }
        }
        viewport={isMobile ? { once: true } : { once: false }}
      >
        <Card className="text-center" style={{ backgroundColor: "#0c1220", color: "white", border: "1px solid rgba(255,255,255,0.08)"}} >
          <Card.Header>{title}</Card.Header>
          <Card.Img
            src={image}
            style={{ 
              height: "250px",
              objectFit: "cover"
             }}
          />
          <Card.Body>
            <Button style={{ backgroundColor: "#2d55ac", borderColor: "#ffffff00" }} href={href}>
              {buttonText}
            </Button>
          </Card.Body>
        </Card>
      </motion.div>
    </Col>
  )
}

// delay is when the animation starts, x and y are the position of the particle
function FloatingParticle({ delay, x, y }: { delay: number; x: number; y: number }) {
  return (
    <motion.div
      style={{
        position: "absolute", // absolute allows to use x% and y% (percentage locations)
        left: `${x}%`,
        top: `${y}%`,
        width: "5px",
        height: "5px",
        borderRadius: "50%", // makes it a circle
        pointerEvents: "none", // particle wont interfere with mouse
        background: "#4d7cff",
        boxShadow: "0 0 15px #4d7cff",
        zIndex: 2
      }}
      animate={{ y: [0, -20, 0], opacity: [0.2, 0.8, 0.2] }}
      transition={{ duration: 4, delay: delay, repeat: Infinity, ease: "easeInOut" }}
    />
  );
}

function CollaborationSection() {
  return (
    <Container
      fluid
      style={{
        padding: "150px 30px",
        textAlign: "center",
        background: "#0b1120",
      }}
    >
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8 }}
    style={{
      maxWidth: "850px",
      margin: "auto",
    }}
  >
    <div
      style={{
        color: "#7da0ff",
        // fontSize: "12px",
        // letterSpacing: "3px",
        // fontWeight: 700,
        marginBottom: "20px",
      }}
    >
      COLLABORATION
    </div>

    <h2
      style={{
        fontSize: "clamp(45px, 6vw, 75px)",
        letterSpacing: "-3px",
        lineHeight: 1,
        fontWeight: 800,
        marginBottom: "30px",
      }}
    >
      Let's build something{" "}
      <span
        style={{
          background: "linear-gradient(110deg, #6d94ff, #45d8c1)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        meaningful.
      </span>
    </h2>

    <p
      style={{
        color: "#8f99aa",
        // fontSize: "17px",
        // lineHeight: 1.8,
        maxWidth: "650px",
        margin: "0 auto 40px",
      }}
    >
      I am interested in research collaborations, academic opportunities,
      industry partnerships, and projects in sustainable construction or nuclear infrastructure.
    </p>

    <Button
      href="mailto:mohamadtarabin@outlook.com"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "15px",
        padding: "14px 23px",
        borderRadius: "7px",
        fontWeight: 600,
        background: "#4d7cff",
        color: "white",
        border: "none",
      }}
    >
      Get in Touch <span>→</span>
    </Button>
  </motion.div>
</Container>
  )
}

function ResearchSection({researchAreas, featuredResearch, isMobile}: {researchAreas: ResearchArea[], featuredResearch: FeaturedResearch[], isMobile: boolean}) {

  return (
    <Container
      id="research"
      style={{
        // padding: "20px 10px 0 10px", 
      }}
    >
      {/* Section heading */}
      <Row
        style={{
          maxWidth: "1000px",
          margin: "0 auto 25px auto", // Top right bottom left. Auto right and left centers the element horizontally
          textAlign: "center",
        }}
      >
        <div
          style={{
            color: highlightedWordColor,
            marginBottom: "20px",
          }}
        >
          RESEARCH AREAS
        </div>

        <h2
          style={{
            fontSize: "clamp(38px, 4vw, 62px)",
            letterSpacing: "-2px",
            lineHeight: 1.05,
            margin: "0 0 25px",
            fontWeight: 800,
          }}
        >
          Exploring the boundaries of{" "}
          <span
            style={{
              color: highlightedWordColor
            }}
          >
            concrete engineering.
          </span>
        </h2>

        <p>
          My research focuses on the development and characterization of high-performance concrete materials and
          structures for demanding engineering applications.
        </p>
      </Row>

      {/* Research carousel */}
      <Row>
        <Carousel className="research-carousel" indicators={true} controls={true} interval={null} slide={true} style={{}}>

          {researchAreas.map((research, index) => (
            <Carousel.Item key={research.title}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                style={{    
                  width: "86%",
                  // height: "90%",
                  margin: "0 auto 50px auto",
                  borderRadius: "18px",
                  border: "1px solid rgba(255,255,255,0.08)",
                  background: "linear-gradient(145deg, rgba(255,255,255,0.06), rgba(255,255,255,0.018))",
                  overflow: "hidden",
                }}
              >
                <Row>
                  <Col
                    xs={{ span: 12 }}
                    lg={{ span: 5 }}
                  >
                    <Image
                      src={research.image}
                      fluid
                      rounded
                      style={{
                        width: "100%",
                        height: isMobile ? "300px" : "400px",
                        objectFit: "cover" // Makes it so that the image does not crop
                      }}
                    />
                  </Col>

                  <Col
                    xs={{ span: 12 }}
                    lg={{ span: 7 }}
                    style={{
                      padding: isMobile ? "20px 30px 60px" : "40px 60px 60px 40px",
                      height: "400px"
                    }}
                  >
                    <div
                      style={{
                        color: "#4f5a70",
                        fontSize: "11px",
                        letterSpacing: "2px",
                        marginBottom: "20px",
                      }}
                    >
                      RESEARCH AREA {String(index + 1).padStart(2, "0")} /{" "}
                      {String(researchAreas.length).padStart(2, "0")}
                    </div>

                    <h3
                      style={{
                        fontSize: "clamp(28px, 3vw, 42px)",
                        letterSpacing: "-1px",
                        lineHeight: 1.05,
                        fontWeight: 700,
                        marginBottom: "25px",
                      }}
                    >
                      {research.title}
                    </h3>

                    <div
                      style={{
                        color: "#7da0ff",
                        fontSize: "small",
                        marginBottom: "15px",
                      }}
                    >
                      RELATED RESEARCH
                    </div>

                    <ul
                      style={{
                        paddingLeft: "20px",
                        marginBottom: 0,
                      }}
                    >
                      {research.relatedResearch.map((related) => (
                        <li
                          key={related.doi}
                          style={{
                            marginBottom: "12px",
                            color: "#a7b0c0",
                            lineHeight: 1.5,
                          }}
                        >
                          <a
                            href={related.doi}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#a7b0c0",
                              textDecoration: "none",
                            }}
                          >
                            {related.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </Col>

                </Row>
              </motion.div>
            </Carousel.Item>
          ))}

        </Carousel>
      </Row>

      {/* Featured publications */}
      <Row
        style={{
          marginTop: "50px",
        }}
      >
          <div>
            <h3
              style={{
                marginBottom: "20px",
                fontWeight: "bold",
              }}
            >
              Selected publications
            </h3>
          </div>


        {/* Publication list */}
        <div
          style={{
            borderTop: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          {featuredResearch.map((publication) => (
            <motion.a
              key={publication.title}
              href={publication.doi}
              whileHover={{ x: 8 }}
              transition={{ duration: 0.2 }}
              style={{
                display: "grid",
                gridTemplateColumns: "70px 1fr 30px",
                alignItems: "center",
                gap: "25px",
                padding: "28px 10px",
                borderBottom: "1px solid rgba(255,255,255,0.08)",
                textDecoration: "none",
                color: "white",
              }}
            >
              {/* Year */}
              <div style={{ color: "#4f5a70", }}>
                {publication.year}
              </div>

              {/* Publication information */}
              <div>
                <div
                  style={{
                    color: "#7da0ff",
                    marginBottom: "7px",
                  }}
                >
                  {publication.journal}
                </div>

                <h5>
                  {publication.title}
                </h5>
              </div>

              {/* Arrow */}
              <div
                style={{
                  fontSize: "22px",
                  color: "#68748c",
                }}
              >
                →
              </div>
            </motion.a>
          ))}
        </div>

        {/* Bottom publications button */}
        <div
          style={{
            textAlign: "center",
            marginTop: "45px",
          }}
        >
          <Button
            href="/research"
            style={{
              padding: "14px 25px",
              border: "none",
              background: "#4d7cff",
              color: "white",
              fontWeight: 600,
            }}
          >
            Explore All Publications <span style={{ marginLeft: "10px" }}>→</span>
          </Button>
        </div>
      </Row>

      {/* Research impact */}
      <Row
        style={{
          marginTop: "50px",
          marginBottom: "50px",
          padding: isMobile ? "50px 20px" : "40px 50px",
          borderTop: "1px solid rgba(255,255,255,0.08)",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
          background: "linear-gradient(145deg, rgba(255,255,255,0.025), rgba(255,255,255,0.005))",
        }}
      >
        <Col xs={12} style={{ textAlign: "center", color: highlightedWordColor, marginBottom: "20px", }}>
            RESEARCH IMPACT
        </Col>

        {/* Impact statistics */}
        <Col xs={12} md={4} style={{ textAlign: "center", marginBottom: isMobile ? "40px" : "0" }}>
          <div
            style={{
              fontSize: "clamp(40px, 5vw, 60px)",
              fontWeight: 800,
              letterSpacing: "-3px",
              background: "linear-gradient(120deg, white, #758dce)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            9+
          </div>

          <div
            style={{
              color: "#737d90",
              textTransform: "uppercase",
              marginTop: "8px",
            }}
          >
            Journal Publications
          </div>
        </Col>

        <Col xs={12} md={4} style={{ textAlign: "center", marginBottom: isMobile ? "40px" : "0" }}>
          <div
            style={{
              fontSize: "clamp(40px, 5vw, 60px)",
              fontWeight: 800,
              letterSpacing: "-3px",
              background: "linear-gradient(120deg, white, #758dce)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            150+
          </div>

          <div
            style={{
              color: "#737d90",
              textTransform: "uppercase",
              marginTop: "8px",
            }}
          >
            Citations
          </div>
        </Col>

        <Col xs={12} md={4} style={{ textAlign: "center" }}>
          <div
            style={{
              fontSize: "clamp(40px, 5vw, 60px)",
              fontWeight: 800,
              letterSpacing: "-3px",
              background: "linear-gradient(120deg, white, #758dce)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            3
          </div>

          <div
            style={{
              color: "#737d90",
              textTransform: "uppercase",
              marginTop: "8px",
            }}
          >
            Research Tools Developed
          </div>
        </Col>
      </Row>

    </Container>
  )
}


function SoftwareSection() {
  return (
          <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{ duration: 0.8, delay: 0.25 }}
        style={{
          textAlign: "center",
        }}
      >
    <Container
      fluid
      style={{
        padding: "130px 35px",
        background: "linear-gradient(to bottom, transparent, rgba(20,30,55,0.25))",
      }}
    >

      {/* Section heading */}
        <div style={{
          maxWidth: "750px",
          margin: "0 auto 70px auto",
        }}>

        <div
          style={{
            color: "#7da0ff",
            // fontSize: "12px",
            // letterSpacing: "3px",
            // fontWeight: 700,
            marginBottom: "20px",
          }}
        >
          DEVELOPMENTS
        </div>

        <h2
          style={{
            fontSize: "clamp(38px, 4vw, 62px)",
            letterSpacing: "-2px",
            lineHeight: 1.05,
            fontWeight: 800,
            marginBottom: "25px",
          }}
        >
          Developing research and engineering{" "}
          <span style={{ color: highlightedWordColor }} >
            software
          </span>
        </h2>

        <p
          style={{
            color: "#a7b0c0",
            // fontSize: "17px",
            // lineHeight: 1.7,
            margin: 0,
          }}
        >
          I develop software tools that translate engineering methodologies
          and research workflows into practical applications for researchers
          and engineers.
        </p>
        </div>

      {/* Software cards */}

      <Row className="g-4">

        <SoftwareCard
          name="PARSO"
          subtitle="Particle Packing & Radiation Shielding Optimizer"
          description="Design and analysis of UHPC mixtures through particle packing, radiation shielding, sustainability assessment, thermal behaviour, and cost evaluation."
          tags={["Particle Packing", "Radiation", "Sustainability", "Thermal"]}
          href="developments#parso"
        />

        <SoftwareCard
          name="CAST TRACK"
          subtitle="Concrete Testing Management"
          description="Management and visualization of casting schedules, specimen tracking, and testing dates for laboratory workflows."
          tags={["Concrete", "Testing", "Scheduling"]}
          href="developments#casttrack"
        />

        <SoftwareCard
          name="GRAPH TOOLS"
          subtitle="Engineering Data Analysis"
          description="Interactive X-Y data cleaning, visualization, numerical integration, and engineering data processing."
          tags={["Data Cleaning", "Analysis", "Integration"]}
          href="developments#graphtools"
        />

      </Row>

    </Container>
        </motion.div>
  );
}

function SoftwareCard({name, subtitle, description, tags, href,}: {
  name: string;
  subtitle: string;
  description: string;
  tags: string[];
  href: string;
}) {
  return (
    <Col lg={4} md={12}>

      <motion.a
        href={href}
        whileHover={{ y: -8 }}
        transition={{ duration: 0.25 }}
        style={{
          display: "block",
          height: "100%",
          minHeight: "330px",
          padding: "35px",
          borderRadius: "14px",
          background: "linear-gradient(145deg, rgba(255,255,255,0.06), rgba(255,255,255,0.018))",
          border: "1px solid rgba(255,255,255,0.08)",
          textDecoration: "none",
          color: "white",
          position: "relative",
        }}
      >
        {/* <Link to={href}> */}
        
        <div
          style={{
            position: "absolute",
            right: "30px",
            top: "25px",
            fontSize: "25px",
            color: "#68748c",
          }}
        >
          ↗
        </div>

        <div
          style={{
            fontSize: "small",
            // letterSpacing: "2px",
            color: "#7da0ff",
            marginBottom: "30px",
          }}
        >
          RESEARCH SOFTWARE
        </div>

        <h2 style={{ marginBottom: "5px", fontWeight: 700, }}>
          {name}
        </h2>

        <p style={{ color: "#8d97a9", marginBottom: "25px", }} >
          {subtitle}
        </p>

        <p style={{ color: "#9ba4b5", }} >
          {description}
        </p>

        <div
          style={{
            display: "flex",
            gap: "7px",
            flexWrap: "wrap",
            marginTop: "25px",
          }}
        >
          {tags.map((tag) => (
            <span
              key={tag}
              style={{
                border: "1px solid rgba(255,255,255,0.09)",
                color: "#8993a6",
                padding: "6px 9px",
                borderRadius: "100px",
              }}
            >
              {tag}
            </span>
          ))}
        </div>
{/* </Link> */}
      </motion.a>

    </Col>
  );
}
